class VatSwitcher extends HTMLElement {
  constructor() {
    super();
    this.vatSwitchCheckbox = this.querySelector('input[type="checkbox"]');

    // Check if the checkbox exists before adding the event listener
    if (this.vatSwitchCheckbox) {
      this.vatSwitchCheckbox.addEventListener('change', () => this.toggleVAT());
    } else {
      console.error('Checkbox not found in vat-switcher element');
    }
  }

  toggleVAT() {
    const showExcludeVAT = this.vatSwitchCheckbox.checked;
    const includeVat = document.querySelectorAll('[data-include-vat]');

    const priceElements = document.querySelectorAll('[data-price]');
    const comparePriceElements = document.querySelectorAll('[data-price-compare]');

    const excludeVat = document.querySelectorAll('[data-exclude-vat]');



    if(!showExcludeVAT){
      includeVat.forEach(element => {
        element.classList.remove("visually-hidden");
      });

      priceElements.forEach(element => {
        element.classList.remove("visually-hidden");
      });
      comparePriceElements.forEach(element => {
        element.classList.remove("visually-hidden");
      });
      excludeVat.forEach(element => {
        element.classList.add("visually-hidden");
      });
    }else{
      includeVat.forEach(element => {
        element.classList.add("visually-hidden");
      });

      priceElements.forEach(element => {
        element.classList.add("visually-hidden");
      });
      comparePriceElements.forEach(element => {
        element.classList.add("visually-hidden");
      });
      excludeVat.forEach(element => {
        element.classList.remove("visually-hidden");
      });

    }


    // Dispatch a custom event for other parts of your application to listen for
    this.dispatchEvent(new CustomEvent('vatToggle', {
      detail: { showExcludeVAT }
    }));

    localStorage.setItem('showExludeVAT', showExcludeVAT);
  }

  connectedCallback() {
    // Target the checkbox specifically within the label with class "vat-switch"
    this.vatSwitchCheckbox = this.querySelector('.vat-switch input[type="checkbox"]');

    if (this.vatSwitchCheckbox) {
      const storedVatPreference = localStorage.getItem('showExludeVAT');
      if (storedVatPreference !== null) {  // Handle the case where there's no preference yet
        this.vatSwitchCheckbox.checked = (storedVatPreference === 'true');
        this.toggleVAT(); // Apply the preference on initial load
      } else {
        this.toggleVAT(); // Apply the preference on initial load
      }
    } else {
      console.error('Checkbox not found within .vat-switch element');
    }
  }
}

customElements.define('vat-switcher', VatSwitcher);
